import React from 'react';
import { default as pt } from 'prop-types';
import { Button } from 'semantic-ui-react';
import styles from './styles/styles.scss';

/**
 *  New/Create Button
 */
const NewButton = (props) => {
  const { newButtonClick, disableNewButton, loading, text } = props;
  return (
    <Button
      basic
      className={`test-new-button ${styles['button']} ${styles['new-button']}`}
      content={text ? text : 'NEW'}
      disabled={disableNewButton}
      floated="right"
      loading={loading}
      onClick={newButtonClick}
      primary
      size="medium"
    />
  );
};

NewButton.propTypes = {
  newButtonClick: pt.func,
  disableNewButton: pt.bool,
  text: pt.string,
  loading: pt.bool,
};

export default NewButton;



// WEBPACK FOOTER //
// ./src/common/components/buttons/NewButton.js